exports.baseURL = "https://admin.pokevo.jp/";
// exports.baseURL = "http://192.168.1.51:5000/";
exports.key = "uLA>-M&H7zX:Z[`Lgi&4~V`AVSm[TG";
exports.projectName = "pokevo"
